import aboutReducer from './aboutSlice';
import statsReducer from './statsSlice';
import contactReducer from './contactSlice';
import gymkhanaReducer from './gymkhanaSlice';
import communityReducer from './communitySlice';
import driverReducer from './driverSlice';
import { configureStore } from '@reduxjs/toolkit';

const store = configureStore({
    reducer: {
        about: aboutReducer,
        stats: statsReducer,
        contact: contactReducer,
        gymkhana: gymkhanaReducer,
        community: communityReducer,
        driver: driverReducer,
    },
});

export default store;
